import { AR_ATENA_DOMAIN } from 'config';
import { Translate } from 'react-localize-redux';
import { useSelector } from 'react-redux';
import { useI18n } from 'services/i18n/i18n.hooks';
import { selectUserProfile } from 'services/user/user.selectors';
import colors from 'style-utils/colors';
import styled from 'styled-components';
import { trackAnalyticsEvent } from 'utils/functions/adobe-launch';

interface SessionCardProps {
  gameId: number;
  gameType: string;
  gameDescription: string;
  sessionBalance: number;
  token: string;
}

export default function SessionCard(props: SessionCardProps) {
  const { gameType, gameDescription, sessionBalance, gameId, token } = props;

  const userProfile = useSelector(selectUserProfile);
  const { billCode } = userProfile;

  const {
    formatters: { formatCurrency },
  } = useI18n();

  const handleLinkClick = () => {
    trackAnalyticsEvent({
      event: 'link_click',
      event_name: 'nav_click',
      conversion_pagename: 'sessioni-pending',
      position: 'sessioni-pending',
      cta_label: `${gameType}:${gameDescription}`,
    });
  };

  return (
    <SessionCardContainer>
      <GameType>{gameType.toLocaleLowerCase()}</GameType>

      <GameDescription>{gameDescription}</GameDescription>

      <Funds>
        <Translate
          id="text.pendingSessionsBanner.fundsAmount"
          data={{ amount: formatCurrency(sessionBalance) }}
        />
      </Funds>

      <Link
        href={`${AR_ATENA_DOMAIN}/#/launchGame/${billCode}/${token}/1/${gameId}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleLinkClick}
      >
        <Translate id="lbl.pendingSessionModal.resume" />
      </Link>
    </SessionCardContainer>
  );
}

const SessionCardContainer = styled.div`
  &:first-child {
    margin-top: 0;
  }

  margin-top: 12px;
  padding: 12px;
  border: 1px solid ${colors.mediumGrey};
  border-radius: 10px;
  color: ${colors.blackTwelve};
`;

const GameType = styled.div`
  text-transform: capitalize;
  font-size: 12px;
  font-weight: 400;
  color: #44546a;
`;

const GameDescription = styled.div`
  margin-top: 3px;
  font-family: var(--secondary-font-family), sans-serif;
  font-weight: 800;
  font-size: 16px;
`;

const Funds = styled.div`
  margin-top: 3px;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
`;

const Link = styled.a`
  display: block;
  padding: 10px 0 0 0;
  text-decoration: underline;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: ${colors.blackTwelve};
`;
